const colors = {
  rose: '#daacc7',
  green: '#b4e0cf',
  link: '#3A34EB',
}

export default colors
